interface FormCheckBoxProps {
  setChecked: (checked: boolean) => void
  checked?: boolean
  label: string
  info?: string
  labelClassName?: string
  error?: string | undefined
  name?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean

}

const FormCheckBox = ({
  setChecked,
  checked,
  label,
  info,
  labelClassName,
  name,
  onChange,
  disabled,
  error = ''
}: FormCheckBoxProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled && setChecked) {
      setChecked(e.target.checked);
    }
    
    if (!disabled && onChange) {
      onChange(e);
    }
  };

  return (
    <p>
      <input
        className={`mr-1 w-4 h-4 rounded-md ${
          error ? 'border-red-500' : 'border-gray-300'
        } focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
          disabled ? 'cursor-not-allowed opacity-50' : ''
        }`}
        type="checkbox"
        onChange={handleChange}
        checked={checked}
        name={name}
        disabled={disabled}
      />
      <label
        className={`${
          labelClassName ? labelClassName : 'ml-2.5  text-black font-medium leading-6'
        } ${error ? 'text-red-500' : ''}`}
      >
        {label}
      </label>
      {info ? (
        <span title={info} className="cursor-pointer">
          &#9432;
        </span>
      ) : null}
    </p>
  )
}

export default FormCheckBox
